module.exports = __webpack_public_path__ + "img/dataPpt2.933d7bd8.png";